// extracted by mini-css-extract-plugin
export default {"card":"styles__card--hY+PN","card-header":"styles__card-header--OkKHw","card-desktop-title":"styles__card-desktop-title--s4qLC","card-content":"styles__card-content--02OSf"};